var _rect, _rect2, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPpt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 5.5,
    fill: "#DE4949"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 5.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.75 23.25C27.75 24.4926 26.7426 25.5 25.5 25.5H10.5C9.25736 25.5 8.25 24.4926 8.25 23.25V12.75C8.25 11.5074 9.25736 10.5 10.5 10.5H20.6893L27.75 17.5607V23.25ZM25.5 27C27.5711 27 29.25 25.3211 29.25 23.25V17.25C29.25 17.0511 29.171 16.8603 29.0303 16.7197L21.5303 9.21967C21.3897 9.07902 21.1989 9 21 9H10.5C8.42893 9 6.75 10.6789 6.75 12.75V23.25C6.75 25.3211 8.42893 27 10.5 27H25.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1929 17.2371C29.309 16.9568 29.2448 16.6342 29.0303 16.4197L21.8303 9.21974C21.6158 9.00525 21.2932 8.94108 21.013 9.05716C20.7327 9.17325 20.55 9.44673 20.55 9.75007V13.3501C20.55 14.7416 20.7722 15.908 21.5571 16.6929C22.3421 17.4778 23.5084 17.7001 24.9 17.7001H28.5C28.8033 17.7001 29.0768 17.5173 29.1929 17.2371ZM26.6893 16.2001H24.9C23.5915 16.2001 22.9579 15.9723 22.6178 15.6322C22.2777 15.2922 22.05 14.6585 22.05 13.3501V11.5607L26.6893 16.2001Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2754 19.3184H13.0547V18.1523H15.2754C15.6621 18.1523 15.9746 18.0898 16.2129 17.9648C16.4512 17.8398 16.625 17.668 16.7344 17.4492C16.8477 17.2266 16.9043 16.9727 16.9043 16.6875C16.9043 16.418 16.8477 16.166 16.7344 15.9316C16.625 15.6934 16.4512 15.502 16.2129 15.3574C15.9746 15.2129 15.6621 15.1406 15.2754 15.1406H13.5059V22.5H12.0352V13.9688H15.2754C15.9355 13.9688 16.4961 14.0859 16.957 14.3203C17.4219 14.5508 17.7754 14.8711 18.0176 15.2812C18.2598 15.6875 18.3809 16.1523 18.3809 16.6758C18.3809 17.2266 18.2598 17.6992 18.0176 18.0938C17.7754 18.4883 17.4219 18.791 16.957 19.002C16.4961 19.2129 15.9355 19.3184 15.2754 19.3184Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpt);
export default __webpack_public_path__ + "static/media/ppt.001992baa468f31723be72e0dcf1b61b.svg";
export { ForwardRef as ReactComponent };